import * as videoEndpoints from './video';
import { root } from './words-by-video';

export const wordsByVideo = {
  ...root,
  video: {
    ...videoEndpoints.video,
  },
};
